import { VARIANT } from '@/constants';
import {
  FormTextArea as CommonFormTextArea,
  type FormTextAreaProps as CommonFormTextAreaProps,
} from '@monorepo/common';
import type { FieldValues } from 'react-hook-form';

type FormTextAreaProps<T extends FieldValues> = Omit<CommonFormTextAreaProps<T>, 'variant'>;

function FormTextArea<T extends FieldValues>(props: FormTextAreaProps<T>) {
  return <CommonFormTextArea {...props} variant={VARIANT} />;
}

export default FormTextArea;
